function solutionBox (){
  let titleText = '该平台已被禁用，不可访问'
  let contentText = ''
  if (!localStorage.getItem('setTempConfigs')) return
  if(JSON.parse(localStorage.getItem('setTempConfigs')).solutionStatus === false) {
    let imgsrc = require('./src/assets/systembc.png');
    let templateCover = 
    `
          <div id="message-cover">
                <h3>${titleText}</h3>
                <p>${contentText}</p>
          </div>
          <style>
          #message-cover{
                padding-top:80px;
                width:100%;
                background: #fff url(${imgsrc}) no-repeat center bottom 180px;
                background-size: contain;
                position: fixed;
                left:0px;
                top:0px;
                z-index:20211117;
                height: calc(100vh);
                box-sizing: border-box;
          } 
          #message-cover h3{
                margin:0px;
                margin-bottom:8px;
                text-align:center;
                height: 45px;
                font-size: 30px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 45px;     
          } 
          #message-cover p{
                margin:0px;
                margin-bottom:40px;
                text-align:center;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #08224D;
                line-height: 28px;
          }   
          </style>
    `
    let tamplateType = templateCover;
    document.querySelector('body').insertAdjacentHTML("beforebegin",tamplateType); 
  }
}
export default solutionBox